import axios, { AxiosInstance } from 'axios'

import { boot } from 'quasar/wrappers'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const deployment = require('../lib/deployment.json')

declare module 'vue/types/vue' {
  interface Vue {
    $axios: AxiosInstance;
  }
}

const ENV = process.env.DEV ? process.env.NODE_ENV : process.env.ENVIRONMENT
export const axiosHttp: AxiosInstance = axios.create({
  baseURL: deployment['' + ENV].SERVER_URL
  // baseURL: process.env.DEV ? deployment.development.SERVER_URL : deployment.production.SERVER_URL
})

export default boot(({ Vue }: any) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  Vue.prototype.$axios = axiosHttp
})
